/**
 * Canonical paths for the signed-in member area. Link and match against these
 * references — never a string literal — so a future route move is one edit
 * here plus a redirect in `next.config.ts`, not a repo-wide grep.
 */
export const APP_ROUTES = {
  transcriptions: '/app/transcriptions',
  dictionaries: '/app/dictionaries',
  templates: '/app/templates',
  apiKeys: '/app/api-keys',
  account: '/app/account',
  team: '/app/account/team',
  referral: '/app/referral',
} as const

export type AppRoute = (typeof APP_ROUTES)[keyof typeof APP_ROUTES]
